// Kaizen Dashboard layouts
import ErrorHandler from "components/ErrorHandler";
import SignIn from "layouts/authentication/sign-in";
import Empleados from "layouts/empleados";

//PDFs

// Kaizen Dashboard icons
import {
  Forest,
  Group,
  LocalShipping,
  ManageAccounts,
  Person,
  Phishing,
  ReportGmailerrorred,
} from "@mui/icons-material";
import Preinscripcion from "layouts/authentication/preinscripcion";
import Autogestion from "layouts/autogestion";
import ControlPermisos from "layouts/control-permisos";
import ControlPermisosViejos from "layouts/fiscalizacion";
import Infracciones from "layouts/infracciones";
import PermisosPesca from "layouts/permisos-pesca";
import Usuarios from "layouts/usuarios";
import PermisosCaza from "layouts/permisos-caza";
import { GiDeer } from "react-icons/gi";
import PermisosOcCoto from "layouts/permisos-oc-coto";
import ControlOcCoto from "layouts/control-oc-coto";
import GuiasDeTransito from "layouts/guiasDeTransito";
import ControlGuia from "layouts/control-guia";

const routes = [
  {
    type: "collapse",
    name: "Empleados",
    key: "empleados",
    route: "/empleados",
    icon: <ManageAccounts />,
    component: <Empleados />,
    noCollapse: true,
    permiso: "Empleados",
  },
  {
    type: "collapse",
    name: "Solicitantes",
    key: "solicitantes",
    route: "/solicitantes",
    icon: <Group />,
    component: <Usuarios />,
    noCollapse: true,
    permiso: "Solicitantes",
  },
  {
    type: "collapse",
    name: "Autogestión",
    key: "autogestion",
    route: "/autogestion",
    icon: <Person />,
    component: <Autogestion />,
    noCollapse: true,
    permiso: "Autogestion",
  },
  {
    type: "collapse",
    name: "Permisos de pesca",
    key: "permisos-pesca",
    route: "/permisos-pesca",
    icon: <Phishing />,
    component: <PermisosPesca />,
    noCollapse: true,
    permiso: "PermisosPesca",
  },
  {
    type: "collapse",
    name: "Permisos de caza",
    key: "permisos-caza",
    route: "/permisos-caza",
    icon: <GiDeer />,
    component: <PermisosCaza />,
    noCollapse: true,
    permiso: "PermisosCaza",
  },
  {
    type: "collapse",
    name: "Permisos oc y coto",
    key: "permiso-oc-coto",
    route: "/permiso-oc-coto",
    icon: <Forest />,
    component: <PermisosOcCoto />,
    noCollapse: true,
    permiso: "PermisosCaza",
  },
  {
    type: "collapse",
    name: "Guías de tránsito",
    key: "guia-de-transito",
    route: "/guia-de-transito",
    icon: <LocalShipping />,
    component: <GuiasDeTransito />,
    noCollapse: true,
    permiso: "PermisosCaza",
  },
  {
    type: "collapse",
    name: "Infracciones",
    key: "infracciones",
    route: "/infracciones",
    icon: <ReportGmailerrorred />,
    component: <Infracciones />,
    noCollapse: true,
    permiso: "Infracciones",
  },
  {
    route: "/control-permisos/:url",
    component: <ControlPermisos />,
  },
  {
    route: "/control-oc-coto/:url",
    component: <ControlOcCoto />,
  },
  {
    route: "/control-guia/:url",
    component: <ControlGuia />,
  },
  {
    route: "/fiscalizacion",
    component: <ControlPermisosViejos />,
  },
  {
    route: "/error",
    component: <ErrorHandler />,
  },
  {
    route: "/login",
    component: <SignIn />,
  },
  {
    route: "/preinscripcion",
    component: <Preinscripcion />,
  },
];

export default routes;
